module.exports = __webpack_public_path__ + "static/legacy_bn1M@2x-fb0d2df0acb9efaa2b35b350d27ab5f3.jpg";